import { ModelType } from '@/constants';
import PreviewComponent from '@/merchandising/managers/biasing-profile/form/search-preview';
export const PREVIEW_CONFIG = {
    [ModelType.BIASING_PROFILE]: {
        title: 'Biasing Profile',
        component: PreviewComponent,
    },
};
